import updateSeasonFieldSlice from './updateSeasonFieldSlice';

const seasonsSlice = [updateSeasonFieldSlice];

export default seasonsSlice;
